module.exports = kolibriGlobal.coreVue.components.EduLogo;